import {DEFAULT_TIME_ZONE} from 'src/internal/constants';

const browserTimeZone: string = DEFAULT_TIME_ZONE;

/**
 * @see https://sail.stripe.me/apis/intl/browserTimeZone
 */
export default browserTimeZone;
